import React from 'react';
import createReactClass from 'create-react-class';

import { registerField } from 'core/forms';
import sortBy from 'lodash/sortBy';

import FormFieldInitiativeChips from '../components/formFieldInitiativeChips';

const FormFieldInitiativeChipsContainer = createReactClass({
  async handleAddButtonClick() {
    const { schema, updateField, value } = this.props;
    const chips = await schema.onAddButtonClick(value);

    updateField(sortBy(chips, ({ name }) => name.toLowerCase()));
  },

  handleChipClick(chip) {
    const { updateField, value } = this.props;
    const chips = value.filter(({ id }) => id !== chip.id);

    updateField(chips);
  },

  render() {
    const { schema, value } = this.props;

    return (
      <FormFieldInitiativeChips
        addButtonText={schema.addButtonText}
        emptyText={schema.emptyText}
        onAddButtonClick={this.handleAddButtonClick}
        onChipClick={this.handleChipClick}
        chips={value}
      />
    );
  },
});

registerField('InitiativeChips', React.memo(FormFieldInitiativeChipsContainer));

export default FormFieldInitiativeChipsContainer;
